module.exports = __webpack_public_path__ + "img/csv-download.72372cb1.svg";